import { CdkDragDrop, copyArrayItem, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MediaType } from '@klickdata/core/media/src/media-type';
import { ResourceItemService } from '@klickdata/core/resource-item';
import { ResourceItem } from '@klickdata/core/resource-item/src/resource-item';
import { Utils } from '@klickdata/core/util';
import { map, Observable, shareReplay, tap } from 'rxjs';

@Component({
    selector: 'app-material-parent-display-mode-bottom-sheet',
    templateUrl: './material-parent-display-mode-bottom-sheet.component.html',
    styleUrls: ['./material-parent-display-mode-bottom-sheet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialParentDisplayModeBottomSheetComponent implements OnInit {
    public items: ResourceItem[];
    public leftSideItemsDisplay: ResourceItem[] = [];
    public rightSideItemsDisplay: ResourceItem[] = [];
    Utils = Utils;
    public displayLayout: boolean = false;
    constructor(
        protected bottomSheetRef: MatBottomSheetRef<MaterialParentDisplayModeBottomSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        protected resourceItemService: ResourceItemService,
        protected cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.items = this.data.resourceItems.map((item) => {
            if (
                item.metadata?.layout?.align === 'right' ||
                item.mediaData.type === MediaType.IMAGE ||
                item.mediaData.type === MediaType.VIDEO ||
                item.mediaData.type === MediaType.AUDIO
            ) {
                this.rightSideItemsDisplay.push(item);
            } else {
                this.leftSideItemsDisplay.push(item);
            }
            return item;
        });

        // Sort both arrays by item.metadata.layout.order
        this.leftSideItemsDisplay.sort((a, b) => {
            const orderA = a.metadata?.layout?.order ?? 0;
            const orderB = b.metadata?.layout?.order ?? 0;
            return orderA - orderB;
        });

        this.rightSideItemsDisplay.sort((a, b) => {
            const orderA = a.metadata?.layout?.order ?? 0;
            const orderB = b.metadata?.layout?.order ?? 0;
            return orderA - orderB;
        });
        if (this.data.viewModeOnly) {
            this.displayLayout = true;
        }
        this.cdr.markForCheck();
    }
    drop(event: CdkDragDrop<ResourceItem[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        } else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }
    }
    onSubmit() {
        this.bottomSheetRef.dismiss({
            leftSideItems: this.leftSideItemsDisplay,
            rightSideItems: this.rightSideItemsDisplay,
        });
    }
    onCancel() {
        this.bottomSheetRef.dismiss();
    }
    onDisplayLayout() {}
}
